export default {"src":"/_next/static/media/benefitsBg.7ab77f4a.svg","height":821,"width":1512,"blurWidth":0,"blurHeight":0};